module.exports = __webpack_public_path__ + "static/media/Ayato.037d6fa7.png";